/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_AllInputs */

const en_admin_posts_all = /** @type {(inputs: Admin_Posts_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Posts`)
};

/**
* | output |
* | --- |
* | "All Posts" |
*
* @param {Admin_Posts_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_all = /** @type {((inputs?: Admin_Posts_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_all(inputs)
});
export { admin_posts_all as "admin.posts.all" }